// @flow
import type { SampleList } from "../../lib/OnlineTypes";
import React from "react";
import Link from "../Link";
import { fetchSamples } from "./Utils/SamplesFetch";
import Samples from "./Samples";
import SampleSearch from "./SampleSearch";
import InvoiceSampleChargeToolbar from "../invoicing/InvoiceSampleChargeToolbar";
import SampleActionBar from "./SampleActionBar";

type State = {
  sample_list: SampleList,
};

type Props = {
  invoiceId: number,
  clientView: boolean,
};

export default class InvoiceLedgerItems extends React.Component<Props, State> {
  state = {
    visible: false,
    loadedSamples: true,
    sampleList: null,
  };

  showSamples = () => {
    this.setState({ visible: true });
    this.findSamples();
  };

  setSampleList = (sampleList: SampleList) =>
    this.setState({
      sampleList,
      loadedSamples: true,
    });

  findSamples = () => {
    const { invoiceId } = this.props;
    this.setState({ loadedSamples: false });
    fetchSamples({
      invoice_id: invoiceId,
    })
      .then((sample_list) => {
        this.setSampleList(sample_list);
      })
      .catch((e) => {
        this.setState({ loadedSamples: false });
      });
  };

  render() {
    const { sampleList, loadedSamples, visible } = this.state;
    const { invoiceId, clientView } = this.props;

    if (!visible) {
      return (
        <div>
          <Link onClick={this.showSamples}>View Sample Charges</Link>
        </div>
      );
    }
    return (
      <div>
        {!loadedSamples && (
          <p>
            <i className="fa fa-spinner fa-spin" />
            &nbsp; Loading
          </p>
        )}
        {loadedSamples &&
          sampleList && (
            <div style={{ marginTop: 20 }}>
              <Samples
                sample_list={sampleList}
                clientView={clientView}
                showAttributes={false}
                reloadData={() => this.findSamples()}
                ToolbarComponent={clientView ? SampleActionBar : InvoiceSampleChargeToolbar}
                invoiceId={invoiceId}
                viewingSampleCharges
              />
            </div>
          )}
      </div>
    );
  }
}
